
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import Link from './../../zviz2/zviz/components/link';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import {extend} from './../../zviz2/zviz/functions';
import config from './../../config';
import {styleText} from './../../styles';
//import {LifeCycle} from './../zviz2/zviz/cycle';

class FilterController extends GroupController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);

    }

    init(renderer){
        super.init(renderer);
        if(! this.data || ! this.data.name || ! this.data.value){
            console.warn('cannot render filter without data!');
        }
    }

    getFilterName(){
        return config.data.dimensionTitles[this.data.name];
    }

    getFilterValue(){
        if(this.data.value instanceof Array){
            if(this.data.name == 'planned_completion_date'){
                let options = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                return options[parseInt(this.data.value[0])-1] + '-' + options[parseInt(this.data.value[1])-1];
            }else if(this.data.value.length == 2){
                if(this.data.value[0] == this.data.value[1]){
                    return this.data.value[0];
                }
            }
            return this.data.value.join(' OR ');
        }else if(this.data.value instanceof Object){
            return 'Structured value';
        }

        return this.data.value;
    }

    deleteFilter(event){

        state.set('filter.' + this.data.name, null);
    }


}


let Blueprint = extend({
    type: FilterController,
    properties: {
        style: {
            height: (ctrl) => ( (state.get('renderSize') == 'small')? '25px' : '40px'),
            width: (ctrl) => {
                let s = state.get('renderSize');
                if(s == 'large'){
                    return '250px';
                }else if( s == 'small'){
                    return 'auto';
                }else{
                    return '200px';
                }
            },
            backgroundColor: '#f7f3ef',
            display: (ctrl) => ( (state.get('renderSize') == 'small')? 'block': 'inline-block'),
            verticalAlign: 'middle',
            marginTop: '5px'
        },
        data: {isFixed: false}
    },
    children: [
        extend({
            properties:{
                style: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    width: (ctrl) => ( (state.get('renderSize') == 'small')? '5%': '20px'),
                    height: '100%',
                    backgroundColor: '#e8e3df',
                    borderRight: '5px solid #606060',
                    marginRight: '8px'
                }
            }
        }, Rectangle),

        extend({
            properties: {
                style: {
                    width: (ctrl) => {
                        let s = state.get('renderSize');
                        if(s == 'large'){
                            return '190px';
                        }else if( s == 'small'){
                            return '81%';
                        }else{
                            return '140px';
                        }
                    }, 
                    display: 'inline-block',
                    verticalAlign: 'top',
                    overflow: 'hidden'
                }
            },
            children: [
                extend({
                    properties: {
                        style: extend({
                            display: 'block',
                            float: (ctrl) => ( (state.get('renderSize') == 'small')? 'left' : 'none'),
                            height: '20px',
                            lineHeight: '20px',
                            marginRight: '5px',
                            fontSize: (ctrl) => ( (state.get('renderSize') == 'large')? '10pt': '9pt' ),
                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.parent.getFilterName.call(ctrl.parent.parent) + ' ' )
                    }
                }, TextBox),

                extend({
                    properties: {
                        style: extend({
                            display: 'block',
                            height: '20px',
                            lineHeight: '20px',
                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.parent.getFilterValue.call(ctrl.parent.parent) )
                    }
                }, TextBox)
            ]
        }, Group),

        (ctrl) => (ctrl.data.isFixed ?
            [] : 
            extend({
                properties: {
                    style:{
                        display: 'inline-block',
                        verticalAlign: 'top',
                        width:  (ctrl) => ( (state.get('renderSize') == 'small')? '7%' : '25px'),
                        height: '100%',
                        background: 'transparent url(\'' + config.imgPath + 'delete_filter.png\') center top no-repeat'
                    }
                },
                events: {
                    click: (event, ctrl) => { ctrl.parent.deleteFilter(); }
                }
            }, Link)
        )
    ]
}, Group);


export default Blueprint;
export {FilterController, Blueprint};
